export class Ticket {
    type: string;
    currency: string;
    amount: number;
    quantity: number;
    barcode: string;
    id: string;

    constructor() {}

    parse(obj: any) {
        if (obj.Type != null) this.type = obj.Type;
        if (obj.Currency != null) this.currency = obj.Currency;
        if (obj.Amount != null) this.amount = obj.Amount;
        if (obj.Quantity != null) this.quantity = obj.Quantity;
        if (obj.Barcode != null) this.barcode = obj.Barcode;
        if (obj.Id != null) this.id = obj.Id;
    }
}
